import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { SecurityMappingPanelComponent } from './lib/security-mapping-panel.component'
import { SecurityMappingKey } from './panel-key'

export * from './lib/security-mapping.module'
export * from './panel-key'

export const SecurityMappingPanelConfig: PanelConfig = {
  key: SecurityMappingKey,
  title: 'Security Mapping',
  description: 'Create, Delete and View Security Mappings',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: SecurityMappingPanelComponent,
  accessPermission: 'accessSecurityMappingPanel',
}
